var React = require('react');
var GamePackageLinks = require('./GamePackageLinks.jsx');
var ScorecardStrip = require('./ScorecardStrip.jsx');
var GameFooter = require('./GameFooter.jsx');

var GameStripIndex = React.createClass({
    render: function(){

        var sport = this.props.sport;
        var league = this.props.league;
        var classMap = {
            'pregame' : 'pre',
            'live' : 'live',
            'final' : 'post'
        };
        var GameStripProps = {
            scores : this.props.scores,
            teams : this.props.teams,
            time : this.props.time,
            formattedDate : this.props.formattedDate,
            gameStatus : this.props.gameStatus,
            winnerClass : this.props.winnerClass,
            broadcasts : this.props.broadcasts,
            footer : this.props.footer,
            gameDetails: this.props.gameDetails,
            sport: this.props.sport,
            anchor: this.props.anchor
        };
        var articleStyles ={
            'backgroundColor': '#fff',
            'border': '1px solid #ccc',
            'marginBottom': '18px',
            'position': 'relative',
            'width': '100%'
        };

        return (
            <article style={articleStyles} id={this.props.id} data-awayid={this.props.teams.home.id} data-homeid={this.props.teams.away.id}>
                <div className={"scoreboard-top " + (this.props.gameStatus === 'pregame' ? "no-tabs" : "")}>
                    <div className="scoreboard-wrapper">
                        <ScorecardStrip {...GameStripProps} />
                        <GameFooter summary={this.props.gameDetails} text={this.props.footer} gameStatus={classMap[this.props.gameStatus]} sport={sport}/>
                    </div>
                    <GamePackageLinks gameStatus={classMap[this.props.gameStatus]} links={this.props.gameLinks} sport={sport} league={league} />
                </div>
                <div style={{clear:'both'}}/>
            </article>
        );
    }
});

module.exports = GameStripIndex;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/scoreboard/game-strip/index.jsx
 **/